export { default } from './Stacked.js';



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductInformation/Stacked/index.js